import { createElement } from './globalFunctions'
const language = dataLayer[0].shoptet.language

/**
 * Add a title to the filters boolean section
 *
 * @param {string} title - The title to be added to the filters boolean section
 */
const addTitleToFiltersBoolean = (title) => {
	const filtersBoolean = document.querySelector('.filter-section-boolean')
	if (filtersBoolean) {
		const help = filtersBoolean.querySelector('h4')
		if (help) return
		const filtersBooleanHeading = createElement('h4', [], title)
		filtersBoolean.prepend(filtersBooleanHeading)
	}
}

/**
 * Make filter titles clickable
 * Adds an event listener to the filter titles that toggles the visibility of the filter form
 * Saves the state of the filter form visibility to the sessionStorage
 * The state is saved as an array of strings with the class names of the filter sections
 * Use `filter-form-visible` class to show the filter form
 */
const makeFilterTitlesClickable = () => {
	const filterSections = document.querySelectorAll('.filter-section')
	for (const section of filterSections) {
		let heading = section.querySelector('h4')
		if (!heading) continue
		heading.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()
			section.classList.toggle('filter-form-visible')
			let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
				parentClass = e.currentTarget.parentElement.className
			parentClass = parentClass.replace('filter-form-visible', '')
			parentClass = parentClass.trim()
			if (cache.includes(parentClass)) {
				cache = cache.filter((item) => {
					return item !== parentClass
				})
			} else {
				cache.push(parentClass)
			}
			window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
		})
	}
	const priceFilterCustom = document.querySelector('.slider-wrapper')
	if (priceFilterCustom) {
		if (!document.querySelector('.slider-inner')) {
			const sliderHeader = priceFilterCustom.querySelector('.slider-header')
			const sliderContent = priceFilterCustom.querySelector('.slider-content')
			const sliderInner = createElement('div', ['slider-inner'])
			if (sliderHeader && sliderContent) sliderInner.append(sliderHeader, sliderContent)
			priceFilterCustom.append(sliderInner)
		}
		priceFilterCustom.querySelector('h4').addEventListener('click', (e) => {
			priceFilterCustom.classList.toggle('filter-form-visible')
			let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
				parentClass = e.currentTarget.parentElement.classList[0]
			if (cache.includes(parentClass)) {
				cache = cache.filter((item) => {
					return item !== parentClass
				})
			} else {
				cache.push(parentClass)
			}
			window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
		})
	}

	let helperCache = window.sessionStorage.getItem('openedFilters')
	if (helperCache) {
		helperCache = JSON.parse(helperCache)
		if (helperCache.length) {
			for (let item of helperCache) {
				item = item.replaceAll(' ', '.')
				item = document.querySelector(`.${item}`)
				if (item) item.classList.add('filter-form-visible')
			}
		}
	}
}
/**
 * Create a button to close subcategories
 * Remove `active` class on the subcategories element and the button itself
 * @param {string} text - The text of the button
 */
const createCloseSubcategoriesButton = (text) => {
	const subcategories = document.querySelector('.subcategories')
	if (!subcategories) return
	const closeCategoriesBtn = createElement('button', ['close-categories', 'btn', 'btn-secondary'], text)
	subcategories.after(closeCategoriesBtn)
	closeCategoriesBtn.addEventListener('click', () => {
		subcategories.classList.remove('active')
		closeCategoriesBtn.remove()
	})
}
/**
 * Create a button to show subcategories
 * Toggle `active` class on the subcategories element
 * @param {string} text - The text of the button
 */
const createShowSubcategoriesButton = (text) => {
	const subcategories = document.querySelector('.subcategories')
	if (!subcategories) return
	const showCategoriesBtn = createElement(
		'button',
		['show-categories', 'btn', 'btn-secondary'],
		window.language === 'cs' ? 'Podkategorie' : 'Subcategories'
	)
	subcategories.before(showCategoriesBtn)
	showCategoriesBtn.addEventListener('click', () => {
		subcategories.classList.toggle('active')
		const closeBtn = document.querySelector('.close-categories')
		if (!closeBtn) {
			createCloseSubcategoriesButton(window.language === 'cs' ? 'Zavřít podkategorie' : 'Hide subcategories')
		} else closeBtn.remove()
	})
}

// give ID to bottom description of category, so that it can be refered to from top description
const addIDToDescription = () => {
	const secondaryDesc = document.querySelector('.category__secondDescription')
	if (secondaryDesc) secondaryDesc.id = 'secondDescription'
}

/**
 * Move category banners into products section and merges both products sections
 * @param {number} firstBannerPosition - The position of the first banner
 * @param {number} secondBannerPosition - The position of the second banner
 */
const moveCategoryBannersIntoProducts = (firstBannerPosition = 0, secondBannerPosition = 0) => {
	const categoryBanners = document.querySelectorAll('.banner-category')
	if (!categoryBanners.length) return

	const firstProductBlock = document.querySelector('#products')
	const secondProductBlock = document.querySelector('.products-block:not(#products)')
	if (secondProductBlock) {
		const secondBlockProducts = secondProductBlock.querySelectorAll('.product')
		for (const product of secondBlockProducts) {
			if (firstProductBlock) firstProductBlock.appendChild(product)
		}
		secondProductBlock.remove()
	}
	for (const [index, categoryBanner] of categoryBanners.entries()) {
		if (categoryBanner && firstProductBlock) {
			categoryBanner.classList.add('product')
			let whereToAppend = null
			switch (index) {
				case 0:
					whereToAppend = firstProductBlock.querySelector(`.product:nth-child(${firstBannerPosition})`)
					break
				case 1:
					whereToAppend = firstProductBlock.querySelector(`.product:nth-child(${secondBannerPosition})`)
					break
				default:
					whereToAppend = firstProductBlock.querySelector('.product:last-child')
					break
			}
			if (whereToAppend) {
				whereToAppend.after(categoryBanner)
			} else {
				firstProductBlock.appendChild(categoryBanner)
			}
		}
		if (window.innerWidth < 768) {
			const extendedText = categoryBanner.querySelector('.extended-banner-text')
			const extendedLink = categoryBanner.querySelector('.extended-banner-link')
			if (extendedText) categoryBanner.appendChild(extendedText)
			if (extendedLink) {
				const actualLink = createElement('a', ['btn', 'btn-primary', 'banner-link'], extendedLink.textContent)
				const href = categoryBanner.querySelector('a').href
				actualLink.href = href
				categoryBanner.appendChild(actualLink)
				extendedLink.remove()
			}
		}
	}
}

const categoryHead = () => {
	if (!document.querySelector('.custom-category-wrapper')) {
		// const breadcrumbsWrapper = document.querySelector('.breadcrumbs-wrapper')

		// if (header) {
		// const customCategoryWrapper = document.createElement('div')
		// customCategoryWrapper.classList.add('custom-category-wrapper')
		// if (breadcrumbsWrapper) customCategoryWrapper.append(breadcrumbsWrapper)

		const categoryTop = document.querySelector('.category-top')

		// let desktopImg
		// let mobileImg
		if (categoryTop) {
			const categoryPerex = categoryTop.querySelector('.category-perex')
			const categoryBG = document.querySelectorAll('.category-top p img')
			if (categoryBG.length) {
				let desktopImg
				let mobileImg
				let imagesLoading = []
				categoryBG.forEach((img) => {
					imagesLoading.push(
						new Promise((resolve) => {
							if (img.complete) {
								if (img.naturalWidth > 800) {
									desktopImg = img.src
								} else {
									mobileImg = img.src
								}
								img.closest('p').remove()
								resolve()
							} else {
								img.addEventListener('load', () => {
									if (img.naturalWidth > 800) {
										desktopImg = img.src
									} else {
										mobileImg = img.src
									}
									img.closest('p').remove()
									resolve()
								})
							}
						})
					)
				})
				Promise.all(imagesLoading)
					.then(() => {
						categoryTop.classList.add('custom-category-wrapper')
						const categoryHeaderImage = document.createElement('img')
						categoryHeaderImage.classList.add('category-header-image')
						if (window.innerWidth <= 767) categoryHeaderImage.src = mobileImg
						else categoryHeaderImage.src = desktopImg
						categoryTop.append(categoryHeaderImage)
						const catHeading = categoryTop.querySelector('.category-title')
						const headingPlaceholder = categoryTop.querySelector('.h1-placeholder')
						if (catHeading) {
							if (headingPlaceholder) {
								headingPlaceholder.innerHTML = ''
								headingPlaceholder.append(catHeading)
							} else if (categoryPerex) categoryPerex.prepend(catHeading)
						}
					})
					.catch((e) => {
						console.log(e)
					})
			}
			if (categoryPerex) {
				categoryPerex.classList.add('wrapped')
				const paragraphs = categoryPerex.querySelectorAll('p')
				if (paragraphs.length > 1) {
					const readMoreBtn = createElement(
						'button',
						['btn', 'read-more-btn', 'chevron-after', 'chevron-right-after'],
						language === 'cs' ? 'Číst více' : 'Prečítajte si viac'
					) // jazyk
					categoryPerex.append(readMoreBtn)
					readMoreBtn.addEventListener('click', () => {
						categoryPerex.classList.remove('wrapped')
						categoryPerex.classList.add('open')
						readMoreBtn.remove()
					})
				}
			}
			// const categoryPerex = categoryTop.querySelector('.category-perex')
			// if (categoryPerex) {
			// 	const perexImgs = categoryPerex.querySelectorAll('img')
			// 	if (perexImgs.length) {
			// 		categoryTop.classList.add('custom-category-wrapper')

			// 		// setTimeout(() => {
			// 		perexImgs.forEach((img) => {
			// 			if (img.naturalWidth > 800) desktopImg = img.src
			// 			if (img.naturalWidth <= 800) mobileImg = img.src
			// 			img.parentElement.remove()
			// 		})
			// 		// customCategoryWrapper.classList.add('has-category-img')
			// 		// }, 10)
			// 	}
			// }
			// if (desktopImg !== undefined || mobileImg !== undefined) {
			// 	const categoryHeaderImage = document.createElement('img')
			// 	categoryHeaderImage.classList.add('category-header-image')
			// 	if (window.innerWidth <= 767) categoryHeaderImage.src = mobileImg
			// 	else categoryHeaderImage.src = desktopImg
			// 	categoryTop.append(categoryHeaderImage)
			// 	const catHeading = categoryTop.querySelector('.category-title')
			// 	const headingPlaceholder = categoryTop.querySelector('.h1-placeholder')

			// 	if (catHeading) {
			// 		if (headingPlaceholder) {
			// 			headingPlaceholder.innerHTML = ''
			// 			headingPlaceholder.append(catHeading)
			// 		} else if (categoryPerex) categoryPerex.prepend(catHeading)
			// 	}
			// }
			// customCategoryWrapper.prepend(categoryHeaderImage)
			// customCategoryWrapper.append(categoryTop)
			// categoryTop.classList.add('container')
			// header.after(customCategoryWrapper)
			const subcategories = document.querySelector('.subcategories')
			if (subcategories) {
				// const subcategoriesWrapper = document.createElement('div')
				// subcategoriesWrapper.classList.add('custom-category-wrapper')
				categoryTop.after(subcategories)
				const subcatItems = subcategories.querySelectorAll('li')
				if (subcatItems.length > 5 && window.innerWidth < 768) {
					const showMoreBtn = createElement('button', ['show-more-btn'], language === 'cs' ? 'Ukázat více' : 'Zobraziť viac')
					subcategories.after(showMoreBtn)
					showMoreBtn.addEventListener('click', () => {
						subcategories.classList.toggle('show-all')
						showMoreBtn.remove()
					})
				}
				// subcategories.classList.add('container')
			}
		}
		// }
	}
	// else {
	// 	let catTop = document.querySelector('#content .category-top')
	// 	if (catTop) catTop.remove()
	// }
}
const handleCheckedFilters = () => {
	const filterSections = document.querySelector('.filter-sections')
	if (filterSections) {
		const activeFilters =
			filterSections.querySelectorAll('#filters input[type="checkbox"]:checked+label') ||
			document.querySelectorAll('#filters input[type="checkbox"]:checked+label')
		if (activeFilters.length) {
			// const categoryContent = document.querySelector('#content')
			// const categoryContent = document.querySelector('.category-top')
			let activeFiltersWrapper = document.createElement('div'),
				// activeFiltersTitle = document.createElement('small'),
				activeFiltersList = document.createElement('div')
			// activeFiltersTitle.classList.add('active-title')
			// activeFiltersTitle.innerHTML = '<span>Vybrané filtry:</span>'
			activeFiltersWrapper.classList.add('active-filters')
			// activeFiltersWrapper.appendChild(activeFiltersTitle)
			activeFiltersList.classList.add('active-list')
			// activeFiltersWrapper.appendChild(activeFiltersTitle)
			activeFiltersWrapper.appendChild(activeFiltersList)
			// jazyk
			// activeFiltersTitle.textContent = window.language === 'cs' ? 'VYBRANÉ FILTRY: ' : 'VYBRANÉ FILTRE: '
			activeFilters.forEach((item) => {
				activeFiltersList.appendChild(item.cloneNode(true))
			})
			let deleteFilters = document.querySelector('#clear-filters')
			if (deleteFilters) {
				const deleteFiltersLink = deleteFilters.querySelector('a')
				//jazyk
				if (deleteFiltersLink) deleteFiltersLink.textContent = window.language === 'cs' ? 'Smazat vše' : 'Vymazať všetko'

				// deleteFilters.textContent = 'Zrušit všechny filtry'
				// const deleteClone = deleteFilters.cloneNode(true)
				activeFiltersWrapper.appendChild(deleteFilters)
				// deleteFilters.addEventListener('click', () => {
				// 	$(deleteFilters).click()
				// })
			}
			if (filterSections.querySelector('.active-filters')) filterSections.querySelector('.active-filters').remove()
			const filtersWrapper = document.querySelector('.filters-wrapper')
			const filterID = document.querySelector('#filters-wrapper')
			// if (filtersWrapper) filtersWrapper.after(activeFiltersWrapper)
			if (window.innerWidth > 767 && filterID && document.body.classList.contains('id-738')) {
				filterID.append(activeFiltersWrapper)
			} else filtersWrapper.appendChild(activeFiltersWrapper)
			// if (otherCategory) {
			// 	otherCategory.prepend(activeFiltersWrapper)
			// } else {
			// 	filtersWrapper.parentElement.insertBefore(activeFiltersWrapper, filtersWrapper.nextElementSibling)
			// }

			// filterSections.appendChild(activeFiltersWrapper)
		}
	}
}
const createCloseFiltersButton = (text, unveilBtn) => {
	const filtersWrapper = document.querySelector('.filters-wrapper')
	if (!filtersWrapper || window.innerWidth > 767 || document.querySelector('.close-filter')) return
	const closeFiltersBtn = createElement('button', ['close-filter', 'btn', 'btn-secondary'], text)
	filtersWrapper.after(closeFiltersBtn)
	closeFiltersBtn.addEventListener('click', () => {
		// filtersWrapper.classList.remove('active')
		unveilBtn.classList.remove('active')
		closeFiltersBtn.remove()
		unveilBtn.textContent = language === 'cs' ? 'Zobrazit filtr' : 'Zobraziť filter' // jazyk
	})
}
const handleFiltersAndBtn = () => {
	let unveilBtn = document.querySelector('.filters-unveil-button-wrapper .btn-default.unveil-button')
	const filtersWrapper = document.querySelector('#filters-wrapper')
	if (!unveilBtn) {
		unveilBtn = createElement('button', ['btn-primary', 'unveil-button', 'btn'])
	}
	if (filtersWrapper) filtersWrapper.prepend(unveilBtn)
	unveilBtn.textContent = language === 'cs' ? 'Zobrazit filtr' : 'Zobraziť filter' // jazyk
	if (sessionStorage.getItem('filtersVisible')) {
		unveilBtn.classList.add('active')
		unveilBtn.textContent = language === 'cs' ? 'Zavřít filtr' : 'Zatvoriť filter' // jazyk
		createCloseFiltersButton(language === 'cs' ? 'Zavřít filtr' : 'Zatvoriť filter', unveilBtn) // jazyk
	}
	unveilBtn.addEventListener('click', () => {
		const closeFiltersBtn = document.querySelector('.close-filter')

		unveilBtn.classList.toggle('active')
		if (closeFiltersBtn) {
			closeFiltersBtn.remove()
		} else createCloseFiltersButton(language === 'cs' ? 'Zavřít filtr' : 'Zatvoriť filter', unveilBtn) // jazyk
		if (unveilBtn.textContent === (language === 'cs' ? 'Zobrazit filtr' : 'Zobraziť filter')) {
			unveilBtn.textContent = language === 'cs' ? 'Zavřít filtr' : 'Zatvoriť filter'
			sessionStorage.setItem('filtersVisible', 'true')
		} else {
			sessionStorage.removeItem('filtersVisible')
			unveilBtn.textContent = language === 'cs' ? 'Zobrazit filtr' : 'Zobraziť filter'
		}
	})
}

const handleFiltersInSpecialCategory = () => {
	const filtersWrapper = document.querySelector('.filters-wrapper')
	const unveilBtn = document.querySelector('#filters-wrapper .btn.unveil-button')
	if (!filtersWrapper || document.querySelector('.hide-filter') || !unveilBtn) return
	const closeFiltersBtn = createElement(
		'button',
		['hide-filter', 'btn', 'btn-primary'],
		window.language === 'cs' ? 'Zabalit filtr' : 'Zabaliť filter'
	) // jazyk
	closeFiltersBtn.addEventListener('click', () => {
		unveilBtn.classList.remove('active')
		// closeFiltersBtn.remove()
		sessionStorage.removeItem('filtersVisible')
	})
	filtersWrapper.prepend(closeFiltersBtn)
}

/**
 * Moves top pro
 * Makes all top products visible
 * gives class to the productsTop heading
 * renames heading
 * moves prices to pInIn for each product
 * @param {HTMLElement} whereToPrepend  - The element to which the top products will be inserted in the 1st place
 */
const handleTopProducts = (whereToPrepend) => {
	const productsTop = document.querySelector('#productsTop')
	if (!productsTop) return

	const productsTopHeading = productsTop.previousElementSibling
	if (productsTopHeading) {
		productsTopHeading.classList.add('productsTop-heading')
		if (window.language === 'sk') productsTopHeading.textContent = 'Najobľúbenejšie'
	}
	const productsTopItems = productsTop.querySelectorAll('.product')
	if (productsTopItems.length) {
		for (const product of productsTopItems) {
			product.classList.remove('inactive')
			product.classList.add('active')
			const prices = product.querySelector('.prices')
			const name = product.querySelector('.p-in-in .name')
			if (prices && name) name.after(prices)
		}
	}
	if (whereToPrepend) {
		whereToPrepend.prepend(productsTop)
		if (productsTopHeading) whereToPrepend.prepend(productsTopHeading)
	}
}

export {
	addTitleToFiltersBoolean,
	makeFilterTitlesClickable,
	createShowSubcategoriesButton,
	moveCategoryBannersIntoProducts,
	categoryHead,
	handleCheckedFilters,
	addIDToDescription,
	handleFiltersAndBtn,
	handleFiltersInSpecialCategory,
	handleTopProducts,
}
